import { render, staticRenderFns } from "./express.form.vue?vue&type=template&id=70b17c6c&lang=pug"
import script from "./express.form.vue?vue&type=script&lang=js"
export * from "./express.form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports